import React, { useRef, useState, useEffect } from 'react';
import { ScrollParallax } from 'react-just-parallax';
import DefaultButton from '../components/DefaultButton';
import headerImage from '../assets/lingotti/0082 - Still life Care is gold-Modifica.webp'
import errorImage from '../assets/error/404error.png'
import fromImage from '../assets/error/lingotti.jpg'

function NotFound404() {

  const createMarkup = (htmlContent) => {
    return {__html: htmlContent};
  };

  const nextSectionRef = useRef(null);

  // Function to scroll to the next section
  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // const [showFirst, setShowFirst] = useState(false);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     //setShowFirst(prev => !prev);
  //     setShowFirst(true);
  //   }, 2000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      <div className='relative z-20 h-lvh overflow-hidden'>
              <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
                <img src={headerImage} alt='background' className="absolute top-0 left-0 w-full h-full object-cover" />
              </ScrollParallax>
          <div className="absolute top-0 left-0 bg-black bg-opacity-40 w-full h-full flex flex-col gap-5 justify-center items-center">
              
              {/* <div style={{ position: "relative", width: "500px", height: "300px" }}>
                <img
                  src={fromImage}
                  alt="First"
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: showFirst ? 0 : 1,
                    transition: "opacity 1s ease-in-out",
                  }}
                />
                <img
                  src={errorImage}
                  alt="Second"
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: showFirst ? 1 : 0,
                    transition: "opacity 1s ease-in-out",
                  }}
                />
              </div> */}
              <div className="flex justify-end text-start ps-15  mx-[5%] md:ml-[5%]">
                <div className='lg:w-full'>
                  <h2 className="lg:text-5xl text-4xl text-white font-semibold space-y-6 text-center mb-6" data-aos="fade-up" data-aos-duration="1000">
                    404
                    <br/>
                    PAGINA NON TROVATA
                  </h2>
                  <DefaultButton text='Torna alla home' link='/' dark={true} buttonClass='w-full' />
                </div>
              </div>
          </div>
      </div>
      <div ref={nextSectionRef}>
      </div>
    </>
  );
}

export default NotFound404;
